import { TurboModuleRegistry } from 'react-native';

/**
 * Values are in bytes.
 */

export default TurboModuleRegistry.getEnforcing('FileAccess');
//# sourceMappingURL=NativeFileAccess.js.map